"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPlatformSource = exports.CustomerSource = void 0;
var CustomerSource;
(function (CustomerSource) {
    /**
     *  Customer imported from an external source
     */
    CustomerSource["Imported"] = "IMPORTED";
    /**
     *  Customer added manually by a user
     */
    CustomerSource["Manually"] = "MANUALLY";
    /**
     *  Customer imported from mobile contacts
     */
    CustomerSource["MobileContacts"] = "MOBILE_CONTACTS";
    /**
     *  Customer created through a manual order
     */
    CustomerSource["ManualOrder"] = "MANUAL_ORDER";
    /**
     *  Customer created via a storefront order
     */
    CustomerSource["StorefrontOrder"] = "STOREFRONT_ORDER";
})(CustomerSource || (exports.CustomerSource = CustomerSource = {}));
var CustomerPlatformSource;
(function (CustomerPlatformSource) {
    CustomerPlatformSource["AndroidApp"] = "ANDROID_APP";
    CustomerPlatformSource["DesktopWeb"] = "DESKTOP_WEB";
    CustomerPlatformSource["iOSApp"] = "IOS_APP";
    CustomerPlatformSource["MobileWeb"] = "MOBILE_WEB";
})(CustomerPlatformSource || (exports.CustomerPlatformSource = CustomerPlatformSource = {}));
//# sourceMappingURL=customer.js.map